<template>
  <div class="supports-tab">
    <v-data-table
      :headers="headers"
      :items="brackets"
      item-key="uuid"
      fixed-header
      height="500"
      :items-per-page="-1"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Supports</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.label"
                        label="Nom"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model.number="editedItem.buy_price"
                        label="Prix d'achat"
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model.number="editedItem.selling_price"
                        label="Prix de vente"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Buy price -->
      <template #item.buy_price="{ value }">
        {{ value | currency }}
      </template>

      <!-- Selling price -->
      <template #item.selling_price="{ value }">
        {{ value | currency }}
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import BracketsRepo from "@/repositories/settings/brackets";

  export default {
    name: "SupportsTab",
    data() {
      return {
        headers: [
          {
            text: "Libellé",
            align: "left",
            value: "label"
          },

          {
            text: "Prix d'achat",
            align: "left",
            value: "buy_price"
          },

          {
            text: "Prix de vente",
            align: "left",
            value: "selling_price"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        brackets: [],

        defaultItem: {
          label: "",
          buy_price: null,
          selling_price: null
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          label: "",
          buy_price: null,
          selling_price: null
        }
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter un accessoire"
          : "Modifier un accessoire";
      }
    },
    methods: {
      editItem(item) {
        this.editedId = item.id;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      /**
       * Delete a bracket
       */
      async deleteItem(item) {
        confirm("Are you sure you want to delete this item?") &&
          (await BracketsRepo.deleteBracket(item.id));

        this.getBrackets();
      },

      /**
       * Save bracket on server
       */
      async save() {
        if (this.editedId > -1) {
          await BracketsRepo.updateBracket(this.editedId, this.editedItem);
        } else {
          await BracketsRepo.create(this.editedItem);
        }

        this.getBrackets();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all brackets
       */
      async getBrackets() {
        try {
          const { data } = await BracketsRepo.get();
          this.brackets = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getBrackets();
    }
  };
</script>

<style lang="scss">
  .supports-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
